import { Link } from '@/ui'

interface HelpProps {
    handleHelpOpen: () => void
}
function Help({handleHelpOpen}: HelpProps) {
  return (
    <Link 
        onClick={handleHelpOpen}
        sx={{ 
            color: 'text.secondary', 
            textDecoration: 'underline', 
            fontSize: '0.875rem', 
            cursor: 'pointer',
            '&:hover': { color: 'primary.main' } 
        }}
        >
        Help?
    </Link>
  )
}

export default Help